export default __webpack_public_path__ + "static/cooling_towers_b.51016b2b388cd99cdaab946f3ab5e089.png";